
import Vue from "vue";
import {TokenStore} from "@/utils/token-store";
import {TicketMessageAttention} from "@/models/ticket-message-attention";

export default Vue.extend({
	props: {
		value: {
			type: Array as () => TicketMessageAttention[],
			required: true
		}
	},
	computed: {
		attentions(): any[]{
			return this.value.map(u => {
				if(!u.admin){
					return;
				}
				u.admin.name = u.admin.name.split(" ")[0];
				return u;
			});
		}
	},
	methods: {
		addComma(i: number): string {
			if (i != this.value.length - 1) {
				return ", ";
			}
			return "";
		},
		attentionForMe(value: TicketMessageAttention): boolean {
			if (value.admin) {
				if (value.admin.email == TokenStore.email) {
					return true;
				}
			}
			return false;
		},
		async triggerToggleAsRead(value: TicketMessageAttention) {
			/*if (!this.attentionForMe(value)) {
				return;
			}*/
			if (value.read) {
				let confirm = await this.$wf.confirm("Deze attenties opnieuw activeren?", "Ja", "Neen", "Opgelet!");
				if (confirm) {
					this.$emit("toggle-as-read", value);
				}
			} else {
				this.$emit("toggle-as-read", value);
			}
		},
	}
});
